



































import { defineComponent, useContext } from '@nuxtjs/composition-api'
import { temiCaldiLink } from '~/helpers/trackings/24orepro/pages';

export default defineComponent({
    props: {
        classes: {
            type: Object,
            default: () => { return {} }
        },
        title: {
            type: String,
            required: true
        },
        subtitle: {
            type: String
        },
        imageSrc: {
            type: String
        }
    },
    data() {
        return {
            sprite: require('~/assets/solepro/spritemap.svg')
        }
    },
    setup() {
        const trackTemiCaldiLink = () => temiCaldiLink();
        const { app } = useContext()
        return {
            trackTemiCaldiLink,
            IMAGE_STATIC_REPLACEMENT: app.$config.IMAGE_STATIC_REPLACEMENT,
            IMAGE_CDN_REPLACEMENT: app.$config.IMAGE_CDN_REPLACEMENT,
        }
    },
})
